export default "__VITE_ASSET__10fc2b7c__"